

export const SET_ALL_USERS = 'boilerplate/UserManagement/SET_ALL_USERS';
export const LOADER_STATUS = 'boilerplate/UserManagement/LOADER_STATUS';
export const SET_CREATE_USER_MODAL = 'boilerplate/UserManagement/SET_CREATE_USER_MODAL';
export const GET_ALL_COMPANIES = 'boilerplate/UserManagement/GET_ALL_COMPANIES';
export const SET_ALL_STATE_CODE = 'boilerplate/UserManagement/SET_ALL_STATE_CODE';